import React, { useState, useEffect } from 'react';
import {Form,Spin,message,Button,Row,Col,InputNumber} from "antd";
import _AdminService from 'modules/AdminService';
import moment from "moment";
import ButtonComponent from 'components/controls/Button';
import { PROJECT_LOGO } from 'constants/constants';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import PageHeader from 'components/enterprise/PageHeader';
import { routesAdmin } from 'routes/Routes';
import _utils from 'modules/Utils';
// "Admit Card / Hall Ticket Standardization, Center Binding & Language Fix" phase: this admin lookup
// screen renders the same document a candidate downloads (ExamCard2_new.jsx) — reuses that file's own
// examCard.* dictionary keys (see modules/i18n/pages/examCard.js) rather than a second, parallel set,
// so the admin's view and the candidate's own download always show identical title/labels/terminology.
import Text from 'components/Text/Text';

const ViewExamCardByAdmin = (props) => {
    const [loading, setLoading] = useState(true);
    const [candidateData, setCandidateData] = useState([]);
    const { form } = props;

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        form.validateFields(async (err, values) => {
            if (!err) {
                if (values.applicationId || values.rollNumber) {
                    setLoading(true);
                    let appId = values.applicationId || 0;
                    let rollNo = values.rollNumber || 0;

                    try {
                        const response = await _AdminService.GetStudentReceiptDataForAdmin(appId, rollNo);
                        console.log("response", response)
                        if (response.data.IsSuccess) {
                            setCandidateData(response.data.Obj);
                        } else {
                            if (response.data && response.data.Message) {
                                message.error(response.data.Message);
                            } else {
                                message.error("Something went wrong!");
                            }
                        }
                    } catch (error) {
                        message.error("Error fetching data.");
                    }
                    setLoading(false);
                } else {
                    message.error("Either Application ID or Roll Number is required!");
                }
            }
        });
    };

    const handleReset = () => {
        form.resetFields();
        setCandidateData([]);
    };

    // const onPrint = () => {
    //     setLoading(true);
    //     window.scrollTo(0, 0);
    //     html2canvas(document.querySelector("#divReceiptPrint"), {
    //         scale: 3, allowTaint: true, useCORS: true
    //     }).then(canvas => {

    //         const imgData = canvas.toDataURL('image/jpeg');
    //         const imgWidth = 190;
    //         const pageHeight = 300;
    //         const imgHeight = (canvas.height * imgWidth) / canvas.width;
    //         let heightLeft = imgHeight;
    //         // const doc = new jsPDF('pt', 'mm');
    //         const doc = new jsPDF({
    //             // orientation: 'p',
    //             unit: 'mm',
    //             // format: 'a4',
    //             compressPdf: true
    //         });
    //         let position = 0;
    //         doc.addImage(imgData, 'JPEG', 10, 0, imgWidth, imgHeight + 70);
    //         heightLeft -= pageHeight;
    //         while (heightLeft >= 0) {
    //             position = heightLeft - imgHeight;
    //             doc.addPage();
    //             doc.addImage(imgData, 'JPEG', 10, position, imgWidth, imgHeight + 90);
    //             heightLeft -= pageHeight;
    //         }

    //         doc.save("Candidate_ExamCard.pdf");
    //         // updateExamCardDownloadStatus();
    //         setLoading(false)
    //     });
    // }

    const onPrint = () => {
        // setLoading(true);

        window.scrollTo(0, 0);
        const originalDiv = document.querySelector("#divReceiptPrint");

        // Clone the div to avoid modifying the original
        const clonedDiv = originalDiv.cloneNode(true);
        clonedDiv.style.position = "absolute";
        clonedDiv.style.left = "-9999px";
        clonedDiv.style.width = "1400px";
        document.body.appendChild(clonedDiv);


        html2canvas(clonedDiv, {
            scale: 3, allowTaint: true, useCORS: true
        }).then(canvas => {
            const imgData = canvas.toDataURL('image/jpeg', 0.8);

            const doc = new jsPDF({
                orientation: 'p',
                unit: 'pt',
                format: 'a4',
                compressPdf: true
            });

            const pageWidth = 595.28;
            const pageHeight = 825.89;

            const margin = 1; // Margin for all sides
            const contentWidth = pageWidth - margin * 2;
            const contentHeight = pageHeight - margin * 2;

            const widthRatio = contentWidth / canvas.width;
            const heightRatio = contentHeight / canvas.height;
            const ratio = Math.min(widthRatio, heightRatio);

            const canvasWidth = canvas.width * ratio;
            const canvasHeight = canvas.height * ratio;

            // Center the image within the margins
            const xOffset = margin + (contentWidth - canvasWidth) / 2;
            const yOffset = margin;

            doc.addImage(imgData, 'JPEG', xOffset, yOffset, canvasWidth, canvasHeight);
            doc.save(_utils.buildHallTicketFileName(candidateData.studentPersonalModel));
            document.body.removeChild(clonedDiv);
            setLoading(false);
        });
    };

    // const updateExamCardDownloadStatus = async () => {
    //     try {
    //         let response = await _AdminService.UpdateStudentExamCardDownloadFlag(true);
    //     } catch (e) {
    //         console.log('Error: ', e);
    //     }
    //     setLoading(false);
    // }

    const onApplicationIdChange = (value) => {
        form.setFieldsValue({ rollNumber: undefined });
        setCandidateData([]);
    };

    const onRollNumberChange = (value) => {
        form.setFieldsValue({ applicationId: undefined });
        setCandidateData([]);
    };

    return (
        <>
            <Spin size="large" spinning={loading}>

                <div className="admin-container p-4">
                    <div className="whiteBg gl-bxbr p-4 mb-4 max1200 m-auto">
                        <PageHeader title="View Hall Ticket" breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'View Hall Ticket' }]} />
                        <Form
                            layout="vertical"
                            onSubmit={handleSubmit}
                        >
                            <div className="admin-inner-wrap p-3">
                                <Row gutter={16} align="middle">
                                    <Col xs={24} sm={10}>
                                        <Form.Item label="Application ID" hasFeedback>
                                            {form.getFieldDecorator('applicationId', {
                                                rules: [
                                                    {
                                                        required: false,
                                                    },
                                                ],
                                            })(
                                                <InputNumber
                                                    type="number"
                                                    min={0}
                                                    max={9999999999}
                                                    placeholder="Enter Application ID"
                                                    onChange={onApplicationIdChange}
                                                    style={{ width: '100%' }} // Full width input
                                                />
                                            )}
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} sm={4} style={{ textAlign: 'center', lineHeight: '32px' }}>
                                        <div className='orTxt'>OR</div>
                                    </Col>

                                    <Col xs={24} sm={10}>
                                        <Form.Item label="Roll Number" hasFeedback>
                                            {form.getFieldDecorator('rollNumber', {
                                                rules: [
                                                    {
                                                        required: false,
                                                    },
                                                ],
                                            })(
                                                <InputNumber
                                                    type="number"
                                                    min={0}
                                                    max={9999999999}
                                                    placeholder="Enter Roll Number"
                                                    onChange={onRollNumberChange}
                                                    style={{ width: '100%' }} // Full width input
                                                />
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                            <div className="pt-4 text-center" >
                                <Button type="button" htmlType="submit" className="button-global button-primary autoHeight mr-4 small"><span>Submit</span></Button>
                                <Button type="button" onClick={handleReset} className="button-global button-secondary  autoHeight small"><span>Clear</span></Button>
                            </div>
                        </Form>
                    </div>
                </div>


                {candidateData && Object.keys(candidateData).length > 0 && (


                    <div className='mb-4'>
                        <div className="whiteBg gl-bxbr p-4 mb-4 max1200 m-auto cd-information">
                            <div className="admin-inner-wrap p-3">
                                <div className="container">
                                    <div id="outerBorder" style={{ textAlign: 'center', border: 'solid', borderColor: 'gray' }}>
                                        <div id="divReceiptPrint" style={{ textAlign: 'center', border: 'solid', borderColor: 'transparent', padding: 7 }}>
                                            <div className="mt15">
                                                <img alt='headerLogo' src={PROJECT_LOGO} className='projectLogoSizeWidth' style={{ alignSelf: 'center', cursor: "pointer" }} />
                                            </div>

                                            <h5 className="heading admitCardTxtAlign1">{candidateData.studentPersonalModel.Applied_Post}</h5>
                                            <h5 className="heading admitCardTxtAlign"><Text k="examCard.documentTitle" /></h5>

                                            <div className="receipt_generation_Table1 my-2" style={{ width: '100%' }}>
                                                <table className='table_100_percent tableHiddenBorder'>
                                                    <tbody>
                                                        <tr>
                                                            <td className='table_personal_info' style={{ padding: 0, borderStyle: 'hidden' }}>
                                                                <table style={{ width: '100%' }}>
                                                                    <tbody>
                                                                        <tr>
                                                                            <th className='width_25_Percent'>
                                                                                <Text k="examCard.candidateFullNameLabel" />
                                                                            </th>
                                                                            <td className='displayInRight' colSpan={2} >{(candidateData.studentPersonalModel.First_Name) + ' ' +
                                                                                (candidateData.studentPersonalModel.Middle_Name) + ' ' +
                                                                                (candidateData.studentPersonalModel.Last_Name)}
                                                                            </td>
                                                                        </tr>
                                                                        <tr style={{ height: '25px' }}>
                                                                            <th>
                                                                                <Text k="examCard.formNoLabel" />
                                                                            </th>
                                                                            <td className='displayInRight' >{candidateData.studentPersonalModel.Form_Number}</td>

                                                                            <th rowSpan={4} className='examCardImgWidths' style={{ textAlign: '-webkit-center' }}>
                                                                                <td>
                                                                                    <img className='recDetailsProfileImg' src={candidateData.studentPersonalModel.Profile_Pic_Path} alt="Profile" />
                                                                                </td>
                                                                            </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>
                                                                                <Text k="examCard.rollNumberUserNameLabel" />
                                                                            </th>
                                                                            <td className='displayInRight' >{candidateData.studentPersonalModel.Roll_Number}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>
                                                                                <Text k="examCard.dateOfBirthLabel" />
                                                                            </th>
                                                                            <td className='displayInRight' >{moment(candidateData.studentPersonalModel.Birth_Date).format('DD-MMM-YYYY')}</td>
                                                                        </tr>

                                                                        <tr>
                                                                            <th>
                                                                                <Text k="examCard.genderLabel" />
                                                                            </th>
                                                                            <td className='displayInRight' >{candidateData.studentPersonalModel.Gender}</td>
                                                                        </tr>

                                                                        <tr>
                                                                            <th>
                                                                                <Text k="examCard.disabilityCategoryNameLabel" />
                                                                            </th>
                                                                            <td className='displayInRight' >{candidateData.studentPersonalModel.DisabilityCategoryName ?
                                                                                candidateData.studentPersonalModel.DisabilityCategoryName
                                                                                : "N/A"}</td>

                                                                            <th rowSpan={2} className='examCardImgWidths'>
                                                                                <td>
                                                                                    <img className='receDetailsSignatureImg' src={candidateData.studentPersonalModel.Signature_Path} alt="Signature" />
                                                                                </td>

                                                                                <div className='displayInGrid f-12'>
                                                                                    <Text k="examCard.signatureOnApplicationFormLabel" />
                                                                                </div>
                                                                            </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>
                                                                                <Text k="examCard.isScribeRequiredLabel" />
                                                                            </th>
                                                                            <td className='displayInRight' >{candidateData.studentPersonalModel.IsScribeRequired ? "Yes" : "N/A"}</td>
                                                                        </tr>

                                                                        <tr>
                                                                            <th>
                                                                                <Text k="examCard.examDateLabel" />
                                                                            </th>
                                                                            <td className='displayInRight' >{moment(candidateData.studentPersonalModel.Exam_Date).isValid() ? moment(candidateData.studentPersonalModel.Exam_Date).format("DD-MMM-YYYY") : ''}</td>

                                                                            <th rowSpan={2} className='examCardImgWidths'>
                                                                                <div className='borderBlack signatureBoxAlign'>
                                                                                </div>

                                                                                <div className='displayInGrid f-12'>
                                                                                    <div><Text k="examCard.signatureInvigilatorLine1" /></div>
                                                                                    <div><Text k="examCard.signatureInvigilatorLine2" /></div>
                                                                                </div>
                                                                            </th>
                                                                        </tr>

                                                                        <tr>
                                                                            <th>
                                                                                <Text k="examCard.examTimeLabel" />
                                                                            </th>
                                                                            <td className='displayInRight' >{candidateData.studentPersonalModel.Exam_Time}</td>
                                                                        </tr>

                                                                        <tr>
                                                                            <th>
                                                                                <Text k="examCard.reportingTimeLabel" />
                                                                            </th>
                                                                            <td className='displayInRight' >
                                                                                <Text k="examCard.reportingTimeNote" />
                                                                            </td>

                                                                            {/* <th rowSpan={2} className='examCardImgWidths'>
                                                                                <div className='borderBlack signatureBoxAlign'>
                                                                                </div>

                                                                                <div className='displayInGrid f-12'>
                                                                                    <div>Invigilator's Signature</div>
                                                                                    <div>पर्यवेक्षकाची स्वाक्षरी</div>
                                                                                </div>
                                                                            </th> */}
                                                                        </tr>

                                                                        <tr>
                                                                            <th>
                                                                                <Text k="examCard.gateClosureTimeLabel" />
                                                                            </th>
                                                                            <td className='displayInRight' >
                                                                                <Text k="examCard.gateClosureNote" />
                                                                            </td>
                                                                        </tr>

                                                                        <tr>
                                                                            <th>
                                                                                <Text k="examCard.examCentreDetailsLabel" />
                                                                            </th>
                                                                            <td className='displayInRight' colSpan={2}>
                                                                                {candidateData.studentPersonalModel.CenterName}<br />
                                                                                {candidateData.studentPersonalModel.CenterAddress}
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>

                                                        </tr>
                                                    </tbody>
                                                </table>

                                                {/* <div className='admitCardIdPassAlign'>
                                                    <div className='displayFlex'>USERNAME :</div>
                                                    <div className='displayFlex'>{candidateData.studentPersonalModel.Roll_Number}</div>
                                                    <div className='displayFlex'>PASSWORD :</div>
                                                    <div className='displayFlex'>{candidateData.studentPersonalModel.Mobile_Number}</div>
                                                </div> */}

                                                <div className='admitCardIdPassAlign'>
                                                    <div className='displayFlex' style={{ marginRight: "15px", fontSize: "14px", fontWeight: "bold" }}><Text k="examCard.usernameRollNumberLabel" /></div>
                                                    <div style={{ marginRight: "auto", fontSize: "14px", fontWeight: "bold" }}>{candidateData.studentPersonalModel.Roll_Number}</div>
                                                    <div className='displayFlex' style={{ marginRight: "15px", fontSize: "14px", fontWeight: "bold" }}><Text k="examCard.passwordLabel" /></div>
                                                    <div style={{ marginRight: "15px", fontSize: "14px", fontWeight: "bold" }}>{candidateData.studentPersonalModel.Mobile_Number}</div>
                                                </div>

                                                <div className='impInstrAlign1'>
                                                    <div className='impInst1Title'><Text k="examCard.importantNoteHeading" /></div>
                                                    <p className='mb7'><span>&bull;</span><span className='ml15'><Text k="examCard.colorPrintNote" /></span></p>
                                                    <p className='mb7'><span>&bull;</span><span className='ml15'><Text k="examCard.invigilatorAuthorityNote" /></span></p>
                                                    <p className='displayFlex mb0'>
                                                        <span>&bull;</span>
                                                        <span className='ml15 displayFlex'><Text k="examCard.roughSheetNote" /></span>
                                                    </p>
                                                </div>

                                                <label className='instrLabel' style={{ marginTop: "40px", fontSize: "20px", marginBottom: "20px" }}><Text k="examCard.importantInstructionsHeading" /></label>
                                                <div className='examcard_note1'>
                                                    <div className='displayFlex mb7'>
                                                        <span className='mr30'>1)</span>
                                                        <span><Text k="examCard.instruction1" /></span>
                                                    </div>

                                                    <div className='displayFlex mb7 fBold'>
                                                        <span className='mr30'>2)</span>
                                                        <span><Text k="examCard.instruction2" /></span>
                                                    </div>

                                                    <div className='displayFlex mb7 fBold'>
                                                        <span className='mr30'>3)</span>
                                                        <span><Text k="examCard.instruction3" /></span>
                                                    </div>

                                                    <div className='displayFlex mb7'>
                                                        <span className='mr30'>4)</span>
                                                        <span><Text k="examCard.instruction4" /></span>
                                                    </div>

                                                    <div className='displayFlex mb7 fBold'>
                                                        <span className='mr30'>5)</span>
                                                        <span><Text k="examCard.instruction5" /></span>
                                                    </div>

                                                    <div className='displayFlex mb7'>
                                                        <span className='mr30'>6)</span>
                                                        <span><Text k="examCard.instruction6" />
                                                            <div><Text k="examCard.instruction6a" /></div>
                                                            <div><Text k="examCard.instruction6b" /></div>
                                                            <div><Text k="examCard.instruction6c" /></div>
                                                        </span>
                                                    </div>

                                                    <div className='displayFlex mb7'>
                                                        <span className='mr30'>7)</span>
                                                        <span><Text k="examCard.instruction7" />
                                                            <div><Text k="examCard.instruction7a" /></div>
                                                            <div><Text k="examCard.instruction7b" /></div>
                                                        </span>
                                                    </div>

                                                    <div className='displayFlex mb7'>
                                                        <span className='mr30'>8)</span>
                                                        <span><Text k="examCard.instruction8" /></span>
                                                    </div>

                                                    <div className='displayFlex mb7'>
                                                        <span className='mr30'>9)</span>
                                                        <span><Text k="examCard.instruction9" /></span>
                                                    </div>

                                                    <div className='displayFlex mb7'>
                                                        <span className='mr20'>10)</span>
                                                        <span><Text k="examCard.instruction10" /></span>
                                                    </div>

                                                    <div className='displayFlex mb7'>
                                                        <span className='mr20'>11)</span>
                                                        <span><Text k="examCard.instruction11" /></span>
                                                    </div>

                                                    <div className='displayFlex mb7'>
                                                        <span className='mr20'>12)</span>
                                                        <span><Text k="examCard.instruction12" /></span>
                                                    </div>

                                                    <div className='displayFlex mb7'>
                                                        <span className='mr20'>13)</span>
                                                        <span><Text k="examCard.instruction13" /></span>
                                                    </div>

                                                    <div className='displayFlex mb7'>
                                                        <span className='mr20'>14)</span>
                                                        <span><Text k="examCard.instruction14" /></span>
                                                    </div>

                                                    <div className='displayFlex mb7'>
                                                        <span className='mr20'>15)</span>
                                                        <span><Text k="examCard.instruction15" /></span>
                                                    </div>

                                                    <div className='displayFlex mb7'>
                                                        <span className='mr20'>16)</span>
                                                        <span><Text k="examCard.instruction16" /></span>
                                                    </div>

                                                    <div className='displayFlex mb7 fBold'>
                                                        <span className='mr20'>17)</span>
                                                        <span><Text k="examCard.instruction17" /></span>
                                                    </div>

                                                    <div className='displayFlex mb7 fBold'>
                                                        <span className='mr20'>18)</span>
                                                        <span><Text k="examCard.instruction18" /></span>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12" style={{ "marginTop": "15px" }}>
                                    <div className="form-action d-flex justify-content-end">
                                        <ButtonComponent
                                            id="btnPrint"
                                            type="button"
                                            value={<div className='displayInGrid'><Text k="examCard.printDownloadButton" /></div>}
                                            className="button-global button-primary autoWidth autoHeight"
                                            onClick={() => onPrint()}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                )}
            </Spin>
        </>
    );
};

export default Form.create()(ViewExamCardByAdmin);
